import React, { useState } from 'react';

import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Navbar from './components/Layout/Navbar';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PermissionGate from './components/Permissions/PermissionGate';
import LogoutPage from './pages/LogoutPage';
import ProfilePage from './pages/ProfilePage';
import Sidebar from './components/Layout/Sidebar';
import AddSolarUserPage from './pages/AddSolarUserPage';
import SolarUserList from './components/Auth/SolarUserList';
import SolarUserSpecificDashboard from './components/Auth/SolarUserSpecificDashboard';
import { fetchNonGeneratingUsers } from './services/reportService';
import NonGeneratingUsersPage from './pages/NonGeneratingUsersPage';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    alert("Logging out from app .tsx" );
    localStorage.clear();
    return <Redirect to="/login" />;
  }

  return (
    <Router>
      <PermissionGate requiredRole="admin">
        <div className={`${sidebarOpen ? 'd-block' : 'd-none'} d-md-block`}>
          <Sidebar />
        </div>
      </PermissionGate>

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <div className='col-xl-12 col-lg-7'>
            
            <Switch>
              <Route path="/login" render={(props) => <LoginPage {...props} onLoginSuccess={handleLoginSuccess} />} />
              <Route path="/logout" render={(props) => <LogoutPage {...props} onLogout={handleLogout} />} />

              <PermissionGate requiredRole="admin">
                <Navbar isAuthenticated={isAuthenticated} onToggleSidebar={toggleSidebar} />
                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/register" component={RegisterPage} />
                <Route path="/profile" component={ProfilePage} />
                <Route path="/add-solar-user" component={AddSolarUserPage} />
                <Route path="/solar-users" component={SolarUserList} />
                <Route path="/user-dashboard/:user_id" component={SolarUserSpecificDashboard} />
                <Route path="/non-generating-users" component={NonGeneratingUsersPage} />

              </PermissionGate>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default App;